import MarketplaceBreadcrumbs from './MarketplaceBreadcrumbs'

export default MarketplaceBreadcrumbs
